import { jsxs as r, jsx as o } from "react/jsx-runtime";
import { Tag as c, CustomSupercashbackTag as e, CashbackValueTag as n } from "./style.js";
import { useTranslation as i } from "../../../../hooks/useTranslation/index.js";
const g = ({
  percentage: a = 0,
  ...s
}) => {
  const { t } = i("common");
  return /* @__PURE__ */ r(c, { ...s, "data-visible": !!a, children: [
    /* @__PURE__ */ o(e, { percentage: a }),
    /* @__PURE__ */ r(n, { children: [
      /* @__PURE__ */ r("strong", { children: [
        a,
        "%"
      ] }),
      " ",
      t("super-cashback-percentage-tag-text")
    ] })
  ] });
};
export {
  g as SupercashbackPercentageTag
};
